{
  "formGeneralDescription": "Ce formulaire vous permet de configurer votre connecteur PKI, actuellement, seules les PKI Microsoft sont supportées par LX CONNECT.",
  "formRootCaDescription": "La RootCA doit être au format .PEM et doit peser moins de 1Mo.",
  "validation": {
    "url": "L'URL du serveur PKI est obligatoire",
    "urlFormat": "Format de l'URL invalide",
    "login": "L'identifiant d'accès au serveur PKI est obligatoire",
    "password": "Le mot de passe du serveur PKI est obligatoire",
    "templateName": "Nom obligatoire",
    "templateFormat": "Nom de template invalide",
    "pemFileSize": "La taille du fichier .PEM doit être inférieure à 1Mo",
    "pemFileMandatory": "Le fichier doit être un .PEM",
    "rootCa": "La rootCA est obligatoire",
    "pemFileEmpty": "Le fichier .PEM ne doit pas être vide",
    "pemFileInvalid": "Le fichier .PEM n'est pas valide"
  },
  "testConnection": {
    "messageSuccess": "La configuration du serveur PKI est valide",
    "messageFailTitle": "Échec Test de connexion",
    "messageFailConnectivity": "URL invalide",
    "messageFailAuthentication": "Couple Identifiant/mot de passe invalide",
    "messageFailRootca": "RootCA invalide",
    "tooltip": "Tester la connexion",
    "ok": "OK",
    "ko": "KO"
  },
  "button": {
    "viewCertificate": "Voir les certificats"
  },
  "filters": {
    "searchByAlias": "Recherche par alias"
  },
  "noPki": "Aucune PKI n'a été trouvée",
  "alias": "Alias",
  "type": {
    "label": "Type",
    "EST": "EST",
    "MICROSOFT": "Microsoft"
  },
  "url": "URL",
  "delete": {
    "title": "Supprimer la connexion PKI",
    "message": "Confirmez-vous la suppression de la connexion à cette PKI ? Plus aucune opération avec cette PKI ne sera possible."
  },
  "form": {
    "title": {
      "create": "Créer une nouvelle connexion",
      "update": "Éditer la connexion"
    },
    "warning": {
      "title": "Certificat PKI requis",
      "message": "Un certificat dédié avec les tags appropriés doit être présent dans le keystore"
    },
    "connectionSettings": {
      "title": "Paramètres de connexion"
    },
    "login": {
      "label": "Login"
    },
    "password": {
      "label": "Mot de passe"
    },
    "specificConfiguration": {
      "templateName": {
        "label": "Nom du template"
      },
      "retryAfter": {
        "label": "Intervalle de temps par nouvelle tentative"
      },
      "label": {
        "urlLabel": "Label"
      }
    },
    "validate": {
      "create": "Ajouter une connexion",
      "update": "Enregister"
    },
    "cancel": {
      "confirm": {
        "title": {
          "create": "Création d’une connexion PKI",
          "update": "Mise à jour d’une connexion PKI"
        },
        "message": {
          "create": "Souhaitez-vous rejeter les informations saisies et abandonner la création de la connexion ? Toutes les données seront perdues.",
          "update": "Souhaitez-vous rejeter les informations saisies et abandonner la mise à jour de la connexion ? Toutes les données seront perdues."
        }
      }
    },
    "validation": {
      "alias": {
        "required": "L'alias est requis",
        "max": "L'alias doit comporter au maximum 50 caractères"
      },
      "url": {
        "required": "L'URL est requis",
        "max": "\nL'URL doit comporter au maximum 120 caractères"
      },
      "type": {
        "required": "Le type est requis"
      },
      "login": {
        "required": "Le login est requis"
      },
      "password": {
        "required": "Le mot de passe est requis"
      },
      "templateName": {
        "required": "Le nom du template est requis"
      },
      "intervalTime": {
        "required": "L'intervalle de temps est requis",
        "min": "La valeur ne peut être inférieure à 60"
      },
      "urlLabel": {
        "max": "Le label doit comporter au maximum 100 caractères",
        "format": "Le label doit contenir uniquement des caractères alphanumériques, des tirets et des underscores"
      }
    },
    "trustChainsAliases": {
      "label": "Certificats associés",
      "selectAll": "Sélectionner tous les certificats",
      "selectSearchPlaceholder": "Rechercher par alias",
      "selectNoResult": "Aucun certificat n'a été trouvé",
      "help": "La PKI sera utilisée en tant que proxy pour renouveler les certificats des devices identifiés par le certificat du truststore, alors qu’elle permettra le renouvellement des certificats du keystore."
    },
    "testConnection": {
      "button": "Tester la connexion",
      "noPassword": "Merci de saisir le mot de passe afin de tester la connexion"
    }
  }
}
